<div class="flex flex-col gap-3" [attr.data-testid]="testId()">
  <ul class="flex flex-wrap gap-x-6 gap-y-2" [attr.data-testid]="testId() + '-legend'">
    @for (criterion of criteria(); track criterion.id) {
      <li
        class="flex items-center gap-2 text-sm"
        [attr.data-testid]="testId() + '-legend-' + criterion.id"
      >
        <span
          class="size-3 rounded-full shrink-0"
          [style.background-color]="criterion.color"
        ></span>
        <span>{{ criterion.translations | translateDirectus }}</span>
      </li>
    }
  </ul>

  <p class="text-sm text-muted-color" [attr.data-testid]="testId() + '-hint'">
    {{ 'project.steps.criteriaWeightsOverview.treemapHint' | transloco }}
    <span class="tabular-nums text-button-red" [attr.data-testid]="testId() + '-total'">
      ({{ totalWeight() | criteriaWeight }})
    </span>
  </p>

  <div
    echarts
    class="block w-full h-[clamp(22rem,62vh,48rem)]"
    [options]="chartOptions()"
    [attr.data-testid]="testId() + '-chart'"
  ></div>
</div>
